import { getCookie, setCookie } from 'cookies-next';

const KEY = 'yv_iid';

export async function getInstallationsYvIid() {
  const cookie = getCookie(KEY);
  if (cookie) {
    return cookie.toString();
  }

  const response = await fetch('/api/installations/install', { method: 'POST' });
  const { id: yvIid } = await response.json();
  setCookie(KEY, yvIid);
  return yvIid as string;
}
